<template>
    <div class="bg"></div>
</template>
<style>
    .bg {
    	position: fixed;
		top: 0;
    	width: 100%;
    	height: 100%;
    }
</style>
<script type="text/babel">
	//import stats from 'stats';
	import {WebGLRenderer} from 'three';
	import * as THREE from 'three';
	import throttle from 'lodash.throttle';
	import debounce from 'lodash.debounce';
	import {Noise} from 'noisejs';
	import {easeCubicInOut} from 'd3-ease';

	export default {
		name:       'background',
		data(){
			return {
				msg: 'hello vue'
			}
		},
		components: {},


		created: function() {
			// todo: detect webgl - https://github.com/mrdoob/three.js/blob/master/examples/js/Detector.js
			this.amplitude          = 400;
			this.variation          = 0.02;
			this.cameraEase         = 0.05;
			this.timeToMorph        = 8000;
			this.timeToMorphOnClick = 700;
			this.startTime          = Date.now();
			this.worldWidth         = 40;
			this.worldHeight        = 20;
			this.morphing           = true;
			this.clickMorphing      = false;

			this.container = null;
            this.camera    = null;
            this.scene     = null;
            this.renderer  = null;
            this.mouseX    = 0;
            this.planeGeo  = null;
            this.data      = [];
            this.nextData  = [];
		},

		mounted: function() {
			this.init();
			this.animate();
			window.addEventListener('resize', debounce(this.handleResize, 100));
			window.addEventListener('mousemove', throttle(this.onMouseMove, 100));
		},

		methods: {
			init:           function() {
				// THREE, scene
				this.container = document.createElement('div');
				this.$el.appendChild(this.container);
				this.scene            = new THREE.Scene();

				// camera
				this.camera = new THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 1, 2000);
				this.camera.position.set(0.0, 400, 400 * 3.5);

				// cube map
				let reflectionCube = new THREE.CubeTextureLoader()
						.setPath('static/textures/cube/')
						.load( [ 'blue.jpg', 'blue.jpg', 'blue.jpg', 'blue.jpg', 'blue.jpg', 'blue.jpg' ] );
				reflectionCube.mapping = THREE.CubeReflectionMapping;
				reflectionCube.format = THREE.RGBFormat;
				this.scene.background = reflectionCube;

				// Mesh
				this.data = this.generateHeight( this.worldWidth, this.worldHeight );
				this.nextData = this.generateHeight( this.worldWidth, this.worldHeight );

				this.planeGeo = new THREE.PlaneGeometry(window.innerWidth * 1.5, 500, this.worldWidth - 1, this.worldHeight - 1);

				let vertices = this.planeGeo.vertices;
				for(let i = 0, j = 0, l = vertices.length; i < l; i++, j += 3) {
					vertices[i].z += (this.data[i]);
				}

				let material = new THREE.MeshPhongMaterial({
					// wireframe: true,
					color:     0xb2d7ff,
					specular:  0x112233,
					envMap:    reflectionCube,
					combine:   THREE.MultiplyOperation,
                    shading:   THREE.SmoothShading,
					reflectivity: 0.9
				} );

				this.plane            = new THREE.Mesh(this.planeGeo, material)
				this.plane.rotation.x = Math.PI / 4;
				this.plane.position.y = window.innerHeight * 0.35;

				this.scene.add(this.plane);

				// Lights

				let ambient = new THREE.AmbientLight( 0x050505 );
				this.scene.add( ambient );
				let directionalLight = new THREE.DirectionalLight( 0xffffff, 2 );
				directionalLight.position.set( 2, 1.2, 10 ).normalize();
				this.scene.add( directionalLight );

				// Renderer

				this.renderer = new THREE.WebGLRenderer({antialias: true});
				this.renderer.setPixelRatio(window.devicePixelRatio);
				this.renderer.setSize(window.innerWidth, window.innerHeight);
				this.container.appendChild(this.renderer.domElement);
			},
			generateHeight: function(width, height) {
				const noise = new Noise();
				noise.seed(Math.random());

				const size   = width * height;
				const data   = new Uint8Array(size);
				// let data = [];
				let value = 0;
				// let quality  = 1;

				for (let x = 0; x < width; x++) {
					data[x] = [];
					for (let y = 0; y < height; y++) {
						// All noise functions return values in the range of -1 to 1.

						// noise.simplex2 and noise.perlin2 for 2d noise
						value = Math.abs(noise.perlin2(x / width, y / height)) * this.amplitude;
						// ... or noise.simplex3 and noise.perlin3:
						// var value = noise.simplex3(x / 100, y / 100, time);

						data[x * height + y] = value; // Or whatever. Open demo.html to see it used with canvas.
						// console.warn((x * height + y ) + ': ' + value + '   (' + x + ',' + y + ')');
					}
				}
				return data;
			},
			animate:        function() {
				requestAnimationFrame(this.animate);
				this.render();
			},
			render:         function() {
				this.moveCamera();

				// fast morph
				if( this.clickMorphing ) {
                    let t = Date.now() - this.startTime;
                    if( Date.now() - this.startTime > this.timeToMorphOnClick ) {
                        this.data = this.nextData;
                        this.nextData = this.generateHeight( this.worldWidth, this.worldHeight );
                        this.startTimer();
                        this.morphing = true;
                        this.clickMorphing = false;
                    }

                    t = t / this.timeToMorphOnClick;
                    if( t > 1 ) {
                        t = 0;
                    }
                    let vertices = this.plane.geometry.vertices;
                    for(let i = 0; i < vertices.length; i++) {
                        // vertices[i].z = this.nextData[i];
                        // vertices[i].z = vertices[i].z - (t * (vertices[i].z - this.nextData[i]));
                        vertices[i].z = this.data[i] - (easeCubicInOut(t) *  (this.data[i] - this.nextData[i]));
                    }

                    let y = 1 - t;
					if( y == 1 ) {
                    	y = 0;
					}

                    this.wiggleShape(y);
                }
				else if( this.morphing ) { // slow morph
                    let t = Date.now() - this.startTime;
                    if( Date.now() - this.startTime > this.timeToMorph ) {
                        this.data = this.nextData;
                        this.nextData = this.generateHeight( this.worldWidth, this.worldHeight );
                        this.startTimer();
                    }

					t = t / this.timeToMorph;
					if( t > 1 ) {
						t = 0;
					}
					let vertices = this.plane.geometry.vertices;
					for(let i = 0; i < vertices.length; i++) {
						// vertices[i].z = this.nextData[i];
						// vertices[i].z = vertices[i].z - (t * (vertices[i].z - this.nextData[i]));
						vertices[i].z = this.data[i] - (easeCubicInOut(t) *  (this.data[i] - this.nextData[i]));
					}
				}

                this.plane.geometry.verticesNeedUpdate = true;
                this.plane.geometry.normalsNeedUpdate = true;
                this.plane.geometry.uvsNeedUpdate = true;
                this.plane.geometry.computeVertexNormals();

				this.renderer.render(this.scene, this.camera);
			},
			startTimer:		function() {
				this.startTime = Date.now();
			},
            wiggleShape:    function(t) {
                let vertices = this.plane.geometry.vertices;
                let z = 0;
                for(let i = 0; i < vertices.length; i++) {
                    z = vertices[i].z + this.amplitude * (this.variation * t) * (Math.random() * 2 - 1);
                    if( z < 0 ) {
                        z = 0;
                    }
                    else if( z > this.amplitude ) {
                        z = this.amplitude;
                    }
                    vertices[i].z = z;
                }
            },
			moveCamera:		function() {
				this.camera.position.x += (this.mouseX - this.camera.position.x) * this.cameraEase;

				this.camera.position.z = 1000;
				this.camera.lookAt(this.scene.position);
			},
			handleResize:   function() {
				this.camera.aspect = window.innerWidth / window.innerHeight;
				this.camera.updateProjectionMatrix();

				this.renderer.setSize(window.innerWidth, window.innerHeight);
                this.plane.position.y = window.innerHeight * 0.35;

                // todo: redraw everything
			},
			onMouseMove:    function(event) {
				this.mouseX = (event.clientX - window.innerWidth * 0.5) * 0.5;
			},
            handleNavClick: function() {
				this.morphing = false;
                this.clickMorphing = true;

				this.data = [];
				let vertices = this.plane.geometry.vertices;
				for(let i = 0; i < vertices.length; i++) {
					this.data[i] = vertices[i].z;
				}
				this.nextData = this.generateHeight( this.worldWidth, this.worldHeight );

                this.startTimer();
            }
		}
	}
</script>



// WEBPACK FOOTER //
// Background.vue?5f57292e